import React, {Component} from 'react';
import NavBarKS from "../../components/NavBarKS";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import ExcelExporter from "../../components/ExcelExporter";
import * as headerContent from "../../constants/exportcontent";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {ACCESS_TOKEN, EntegratorConf, VirtualHost} from "../../constants";
import CTable from "../../components/Table/Table";
import {Button} from 'react-bootstrap';
import {generateURL, request} from "../../helper/APIUtils";
import axios from "axios";
import DateTypePicker from "../../components/DateTypePicker";

import GibDocumentList from "./GibDocumentList";
import Alert from "react-s-alert";
import {
    showEdefterBildirimDocumentStatusInfo,
    showEdefterDocumentStatusInfo,
    showSgkInvoiceInfo
} from "../../helper/permission";
import {getDocumentDetailColumns} from "./helper/columns";
import {getSearchFields} from "./helper/fields";

class DocumentStatusInfo extends Component {
    interval = 0;

    constructor(props) {
        super(props);
        this.state = {
            btnDisabled: false,
            selection: [],
            page: 0,
            size: 10,
            total: 0,
            loading: false,
            content: [],
            dateType: "today",
            section: "gib",
            manual: false,
            waitedList: {},
            detailList: [],
            selectedAll: false,
            selectedDocument: [],
            documentUuid: [],
            selectedItem: null,
            selectedProcessState: {state: null, result: null},
            documentTitle: "",
            documentType: "",
            endpoint: '',
            refresh: false,
            selectedStatus: null,
            currentYear: new Date().getFullYear(),
            searchQuery: undefined,
            entIdentifier: null,
            sgkType: null,
            disabledLoginBtn: false,
            distributorList: [],
            showOwnDocuments: props.showOnDocuments || false
        };
        this._fetchToken = undefined;
        this.setDateType = this.setDateType.bind(this);
        this.fetchDetail = this.fetchDetail.bind(this);
        this.handleDetail = this.handleDetail.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.interval = setInterval(() => this.check(), 500);
        this.getAllDistributors = this.getAllDistributors.bind(this);
        this.changeAllProcessState = this.changeAllProcessState.bind(this);
    }


    componentWillUnmount() {
        //cancel pending requests on page unload.
        if (typeof this._fetchToken !== typeof undefined) {
            this._fetchToken.cancel('unload')
        }
        clearInterval(this.interval);
    }

    componentDidMount() {
        this.getAllDistributors();
    }


    findDistributors(row) {
        if (this.state.distributorList) {
            let distributors = deepCopyObject(this.state.distributorList);
            return distributors.map(distributor => {
                if (distributor[0] === row.parentCustomerId) {
                    return (distributor[1] !== this.state.distributorList[0][1] && distributor[5] !== this.state.distributorList[0][1]) ?
                        (distributor[1].length === 10 ? distributor[2] : (distributor[3].trimEnd() + ' ' + distributor[4])) + (' (' + (distributor[5].length === 10 ? distributor[6] : (distributor[7].trimEnd() + ' ' + distributor[8])) + ')') :
                        (distributor[1].length === 10 ? distributor[2] : (distributor[3].trimEnd() + ' ' + distributor[4]));
                }
            })
        } else {
            return "";
        }
    }

    async getAllDistributors() {
        let self = this;
        let params = {
            url: "/customer/getDistributors",
            method: "get"
        };
        await request(params)
            .then(response => {
                self.setState({distributorList: response.data});
            }).catch(error => {
            });
    }


    check = () => {
        if (EntegratorConf.identifier) {
            clearInterval(this.interval);
            this.setState({entIdentifier: EntegratorConf.identifier});
        }
    };

    fetchDetail(accessor, direction, page, size) {
        let self = this;
        let endpoint = self.state.endpoint;
        let dateType = self.state.dateType;
        let showOwnDocuments = self.state.showOwnDocuments;
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        if (typeof self._fetchToken !== typeof undefined) {
            self._fetchToken.cancel();
        }
        let selectedProcessState = self.state.selectedProcessState;
        const sgkType = self.state.sgkType;
        this._fetchToken = axios.CancelToken.source();
        let params = null;
        if (sgkType) {
            params = {
                url: endpoint + '/sgkUnbillingInvoiceDetail?type=' + sgkType + '&page=' + page + '&size=' + size + searchQuery,
                method: "get",
                cancelToken: self._fetchToken.token
            }
        } else {
            params = {
                url: endpoint + '/detailList?showOnDocuments=' + showOwnDocuments + '&timeType=' + dateType + '&state=' + selectedProcessState.state + '&result=' + selectedProcessState.result + '&page=' + page + '&size=' + size + searchQuery,
                method: "get",
                cancelToken: self._fetchToken.token
            }
        }
        self.setState({loading: true, manual: self.manual === true ? false : self.manual});
        self.props.reload(true);
        self.setState({content: []}, () => request(params)
            .then(function (response) {
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    content: response.data.content,
                    loading: false,
                });
                self.props.reload(false);
            }));
        self.setState({searchQuery: ""});
    }

    setDateType(dateType) {
        let self = this;
        self.setState({dateType});
    }

    isSectionGib() {
        let self = this;
        return self.state.section === "gib";
    }

    handleDetail(data, documentTitle, documentType, endpoint, sgkType) {
        let self = this;
        let page = self.state.page;
        let size = self.state.size;
        let selectedProcessState = self.state.selectedProcessState;
        selectedProcessState.state = data.processState;
        selectedProcessState.result = data.processResult;
        self.setState({
            selectedProcessState,
            selectedStatus: data,
            endpoint,
            section: "detail",
            documentTitle,
            documentType,
            sgkType
        }, () => self.fetchDetail(undefined, undefined, page, size));
        /*    self.fetchDetail(state,result);*/
    }

    isSelected(id) {
        return (this.state.selection.indexOf(id) !== -1);
    }

    toggleCheckboxChange(e, row, id) {
        let self = this;
        let checked = e.target.checked;
        let items = self.state.content;
        let selection = self.state.selection;
        let selectedDocument = self.state.selectedDocument;
        let documentUuid = self.state.documentUuid;
        if (row === "all") {
            let selection = [];
            let selectedDocument = [];
            let documentUuid = [];
            if (checked) {
                items.forEach(item => {
                    selection.push(item[id]);
                    selectedDocument.push(item);
                    documentUuid.push(item.documentUuid);
                });
            }
            self.setState({selection: selection, selectedDocument, documentUuid, selectedAll: checked});
        } else {
            let index = selection.indexOf(row[id]);
            let indexDocument = selectedDocument.indexOf(row);
            let indexDocumentUuid = documentUuid.indexOf(row.documentUuid);
            if (index >= 0) {
                selection = [
                    ...selection.slice(0, index),
                    ...selection.slice(index + 1)
                ];
                selectedDocument = [
                    ...selectedDocument.slice(0, indexDocument),
                    ...selectedDocument.slice(indexDocument + 1)
                ];
                documentUuid = [
                    ...documentUuid.slice(0, indexDocumentUuid),
                    ...documentUuid.slice(indexDocumentUuid + 1)
                ];
            } else {
                selection.push(row[id]);
                selectedDocument.push(row);
                documentUuid.push(row.documentUuid)
            }
            self.setState({
                selectedDocument,
                documentUuid,
                selection: selection,
                selectedAll: ((selection.length > 0) ? (selection.length === self.state.content.length) : false)
            });
        }
    }

    handleBackSection() {
        let self = this;
        self.setState({section: "gib", sgkType: false, content: []});
    }

    handleRefresh() {
        let self = this;
        let refresh = self.state.refresh;
        refresh = !refresh;
        self.setState({refresh});
    }

    getDocumentTypeCodeAccessor() {
        let self = this;
        let documentType = self.state.documentType;
        let result = {
            title: "",
            accessor: ""
        };
        if (["invoice", "archiveInvoice"].includes(documentType)) {
            result.title = "Fatura Türü";
            result.accessor = "invoiceTypeCode";
        } else if (documentType === "despatch") {
            result.title = "İrsaliye Türü";
            result.accessor = "despatchTypeCode";
        } else {
            result.title = "Makbuz Türü";
            result.accessor = "documentType"
        }
        return result;
    }

    prepareExcelField() {
        let self = this;
        let documentType = self.state.documentType;
        let result = {
            url: '',
            header: [],
            type: '',
            customSheetNameUrl: '',
            docType: undefined
        }
        if (documentType === "invoice") {
            result.url = '/outbox/exportXls';
            result.header = headerContent.outboxStatusContent;
            result.type = 'outbox';
            result.customSheetNameUrl = 'outbox/findFirstAndLast'
        } else if (documentType === "despatch") {
            result.url = '/despatchOutbox/exportXls';
            result.header = headerContent.eDespatchOutboxStatusContent;
            result.type = 'eDespatchOutbox'
            result.customSheetNameUrl = 'despatchOutbox/findFirstAndLast'
        } else if (documentType === "archiveInvoice") {
            result.url = '/eArchive/exportXls';
            result.header = headerContent.eArchiveStatusContent;
            result.type = 'eArchive'
            result.customSheetNameUrl = 'eArchive/findFirstAndLast'
        } else if (documentType === "eExpenseNote") {
            result.url = '/newExpenseNote/exportXls';
            result.header = headerContent.expenseNoteStatusContent;
            result.type = 'newExpenseNote'
            result.customSheetNameUrl = 'newExpenseNote/findFirstAndLast'
        } else if (documentType === "mm") {
            result.url = '/archiveVoucher/exportXls';
            result.header = headerContent.archiveVoucherStatusContent;
            result.type = 'archiveVoucher'
            result.customSheetNameUrl = 'archiveVoucher/findFirstAndLast';
            result.docType = 'MUSTAHSILMAKBUZ';
        } else if (documentType === "smm") {
            result.url = '/archiveVoucher/exportXls';
            result.header = headerContent.archiveVoucherStatusContent;
            result.type = 'archiveVoucher'
            result.customSheetNameUrl = 'archiveVoucher/findFirstAndLast';
            result.docType = 'SERBESTMESLEKMAKBUZ';
        }
        return result;
    }

    getExplanationColor() {
        let self = this;
        let selectedStatus = self.state.selectedStatus;
        if (selectedStatus.successFaultProcess === "S")
            return "text-success";
        else if (selectedStatus.successFaultProcess === "F")
            return "text-danger";
        else
            return "text-warning";
    }

    getResultExplanation(row) {
        let self = this;
        let documentType = self.state.documentType;
        let explanation = "";
        if (["invoice", "despatch"].includes(documentType))
            explanation = "(" + row.processResult + ") " + row.resultExplanation;
        else
            explanation = "(" + row.processState + "-" + row.processResult + ") " + row.resultExplanation;
        return explanation;
    }

    copied(envelopeUuid, envelopeType) {
        if (envelopeUuid) {
            Alert.success(envelopeType + " Zarf ETTN:<br/><strong>" + envelopeUuid + "</strong><br/> kopyalandı", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        }
    }

    downloadLink(type, envelopeUuid, isResponse) {
        let self = this;
        let documentType = self.state.documentType;
        let year = self.state.currentYear;
        let url = ``;

        if (!envelopeUuid) {
            let recordIds = self.state.selection;
            let recordsString = recordIds.join(",");
            if (documentType === "invoice")
                url = `api/outbox/downloadSelected?year=${year}&records=${recordsString}&type=${type}`;
            else
                url = `api/despatchOutbox/downloadSelected?records=${recordsString}&type=${type}`;
        } else if (!isResponse) {
            if (documentType === "invoice")
                url = `api/outbox/downloadEnvelopeXML?envelopeUuid=${envelopeUuid}`;
            else
                url = `api/despatchOutbox/downloadEnvelopeXML?envelopeUuid=${envelopeUuid}`;

        } else {
            if (documentType === "invoice")
                url = `api/outbox/downloadResponseEnvelopeXML?year=${year}&documentUuid=${envelopeUuid}`;
            else
                url = `api/despatchOutbox/downloadResponseEnvelopeXML?documentUuid=${envelopeUuid}`;
        }
        return generateURL(url);
    }

    changeProcessState(row) {
        let self = this;
        let documentUuids = [];
        documentUuids.push(row.documentUuid);
        let params = {
            url: '/eSmmArchiveVoucherStatus/changeAllProcessState',
            method: "post",
            data: documentUuids
        };
        request(params)
            .then(function (response) {
                Alert.success("Doküman imzaya gönderildi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
                self.state.content.map((document, index) => {
                    if (document.documentUuid === row.documentUuid) {
                        self.state.content.splice(index, 1);
                    }
                });
                self.setState({page: 0, size: 10},
                    () => self.fetchDetail(undefined, undefined, self.state.page, self.state.size))
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    changeAllProcessState() {
        let self = this;
        let documentUuids = [];
        self.state.content.map(document => {
            documentUuids.push(document.documentUuid);
        })
        let params = {
            url: '/eSmmArchiveVoucherStatus/changeAllProcessState',
            method: "post",
            data: documentUuids
        };
        request(params)
            .then(function (response) {
                Alert.success("Dokümanlar tekrar imzaya gönderildi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
                self.setState({page: 0, size: 10},
                    () => self.fetchDetail(undefined, undefined, self.state.page, self.state.size))
            }).catch(function (error) {
            self.handleBackSection()
            showAxiosError(error);
        });
    }

    impersonateBySourceId(row) {
        let self = this;
        let sourceId = row.sourceId;
        let destinationId = row.destinationId;
        let prepareQuery = {
            query: "&destinationId=" + destinationId,
            value: destinationId,
            active: true
        }
        let params = {
            url: '/user/impersonateSourceId',
            method: "post",
            data: {
                sourceId: sourceId
            }
        };
        request(params)
            .then(function (response) {
                let data = response.data;
                let endpoint = self.setGoPageEndpoint();
                localStorage.setItem(ACCESS_TOKEN, data.accessToken);
                self.props.handleGoPage(endpoint, prepareQuery);
                self.props.onImpersonate(true);

            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    impersonateCustomerId(row) {
        this.setState({disabledLoginBtn: true});
        let self = this;
        let recordId = row.recordId;
        let params = {
            url: '/user/impersonateCustomerId',
            method: "post",
            data: {
                customerId: recordId
            }
        };
        request(params)
            .then(function (response) {
                console.log(response)
                let data = response.data;
                localStorage.setItem(ACCESS_TOKEN, data.accessToken);
                self.props.onLogin();
                self.props.onImpersonate(true);
                self.setState({disabledLoginBtn: false});
            }).catch(function (error) {
            showAxiosError(error);
            self.setState({disabledLoginBtn: false});
        });
    }

    setGoPageEndpoint() {
        let self = this;
        let documentType = self.state.documentType;
        let endpoint = "";
        if (documentType === "invoice")
            endpoint = "/eInvoiceOutbox";
        else if (documentType === "despatch")
            endpoint = "/eDespatchOutbox";
        else if (documentType === "archiveInvoice")
            endpoint = "/eAInvoice";
        else if (documentType === "mm")
            endpoint = "/eVoucherM";
        else if (documentType === "smm")
            endpoint = "/eVoucherS";
        else if (documentType === "eExpenseNote")
            endpoint = "/newExpenseNote";
        return endpoint;
    }

    handleSearch(searchQuery) {
        this.setState({searchQuery, page: 0, size: 10},
            () => this.fetchDetail(undefined, undefined, this.state.page, this.state.size))
    }

    isEntegrator() {
        return this.props.currentUser && this.props.currentUser.entegrator;
    }

    isImpersonateCagriMerkeziAndBayiSorumlusu() {
        return (this.props.impersonateUserRoleId === 3 || this.props.impersonateUserRoleId === 4) && ["smart", "kolaysoft", 'mbtfatura'].includes(VirtualHost.conf.resourcePrefix);
    }

    render() {
        const columns = getDocumentDetailColumns(this, this.isImpersonateCagriMerkeziAndBayiSorumlusu());
        const fields = getSearchFields(this.state.documentType);

        return (
            <div className="row baseBackground">
                <NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}
                          btnDisabled={this.state.btnDisabled} name={this.props.name}
                          selection={this.state.selection}>

                    {/*{hasUserRight(UserRightsEnum.invoice.view, this.props.currentUser) &&*/}
                    <ExcelExporter position="leftSide" url={this.prepareExcelField().url}
                                   sheetName='Belge Durumu'
                                   content={this.state.content} title="Excel'e Aktar"
                                   customSheetNameUrl={this.prepareExcelField().customSheetNameUrl}
                                   selection={this.state.selection}
                                   defaultHeaders={this.prepareExcelField().header}
                                   customExport={false} year={2021}
                                   openCustomizerModal={this.openCustomizerModal}
                                   clearCustomHeaders={this.clearCustomHeaders}
                                   btnDisabled={this.state.selection.length === 0 || this.state.btnDisabled}
                                   type={this.prepareExcelField().type} clearSelection={this.clearSelection}
                                   docType={this.prepareExcelField().docType}
                                   triggerDownloadRequestTooltip={this.props.triggerDownloadRequestTooltip}
                                   stateCodes={this.state.stateCodes}
                                   icon="excel"
                                   impersonateUserRoleId={this.props.impersonateUserRoleId}/>

                </NavBarKS>


                <div className="col-sm-12 satirBasi">
                    <div className="col-sm-12">
                        <div className="row">
                            <div className="col-sm-2">

                                <div className="card-header">
                                    <h4 className="card-title">{'Belge Durumu'}</h4>
                                </div>
                            </div>
                            {
                                this.state.section === "detail" &&
                                <div className="col-sm-10 d-flex justify-content-end">

                                    <Button className="" style={{fontSize: "11px", backgroundColor: "#6e8da2"}}
                                            onClick={() => this.handleBackSection()}>
                                        <i className="fas fa-angle-double-left"></i> Geri Dön
                                    </Button>
                                </div>
                            }
                        </div>
                    </div>


                    <div className="col-sm-12">
                        {
                            this.state.section === "gib" &&
                            <div className="row toolBar">
                                <DateTypePicker selectedDateType={this.state.dateType}
                                                onSetDateType={this.setDateType}/>
                                <Button size={"sm"} className="ml-auto mt-auto mb-auto"
                                        style={{fontSize: "13px", height: "40px", backgroundColor: "#6e8da2"}}
                                        onClick={() => this.handleRefresh()}>
                                    <i className="fas fa-sync-alt"></i>
                                </Button>
                            </div>
                        }


                    </div>

                    {
                        this.state.section === "gib" ?
                            <div className="row col-sm-12">
                                <div className="row col-sm-12">
                                    {((this.props.isEFatura && this.props.name === "myDocumentStatusInfo") ||
                                        (this.props.name === "documentStatusInfo")) &&
                                    < GibDocumentList
                                        type='invoice'
                                        dateType={this.state.dateType}
                                        handleDetail={this.handleDetail}
                                        documentName="e-Fatura"
                                        documentTitle="Fatura Detay Listesi"
                                        refresh={this.state.refresh}
                                        showOnDocuments={this.state.showOwnDocuments}
                                        />
                                    }
                                    {((this.props.isEIrsaliye && this.props.name === "myDocumentStatusInfo") ||
                                        (this.props.name === "documentStatusInfo")) &&
                                    <GibDocumentList
                                        type="despatch"
                                        dateType={this.state.dateType}
                                        handleDetail={this.handleDetail}
                                        documentName="e-İrsaliye"
                                        documentTitle="İrsaliye Detay Listesi"
                                        refresh={this.state.refresh}
                                        showOnDocuments={this.state.showOwnDocuments}
                                    />
                                    }
                                    {((this.props.isEArsiv && this.props.name === "myDocumentStatusInfo") ||
                                        (this.props.name === "documentStatusInfo")) &&
                                    <GibDocumentList
                                        type="archiveInvoice"
                                        dateType={this.state.dateType}
                                        handleDetail={this.handleDetail}
                                        documentName="e-Arşiv"
                                        documentTitle="E-Arşiv Detay Listesi"
                                        refresh={this.state.refresh}
                                        showOnDocuments={this.state.showOwnDocuments}
                                    />
                                    }
                                    {((this.props.isEMM && this.props.name === "myDocumentStatusInfo") ||
                                        (this.props.name === "documentStatusInfo")) &&
                                    <GibDocumentList
                                        type="mm"
                                        dateType={this.state.dateType}
                                        handleDetail={this.handleDetail}
                                        documentName="e-MM"
                                        documentTitle="Makbuz Detay Listesi"
                                        refresh={this.state.refresh}
                                        showOnDocuments={this.state.showOwnDocuments}
                                    />
                                    }
                                    {((this.props.isESMM && this.props.name === "myDocumentStatusInfo") ||
                                        (this.props.name === "documentStatusInfo")) &&
                                    <GibDocumentList
                                        type="smm"
                                        dateType={this.state.dateType}
                                        handleDetail={this.handleDetail}
                                        documentName="e-SMM"
                                        documentTitle="SMM Detay Listesi"
                                        refresh={this.state.refresh}
                                        showOnDocuments={this.state.showOwnDocuments}
                                    />
                                    }
                                    {((this.props.isEGiderPusulasi && this.props.name === "myDocumentStatusInfo") ||
                                        (this.props.name === "documentStatusInfo")) &&
                                    <GibDocumentList
                                        type="eExpenseNote"
                                        dateType={this.state.dateType}
                                        handleDetail={this.handleDetail}
                                        documentName="e-Gider Pusulası"
                                        documentTitle="E-Gider Pusulası Detay Listesi"
                                        refresh={this.state.refresh}
                                        showOnDocuments={this.state.showOwnDocuments}
                                    />
                                    }
                                    {((this.props.isEdefter && this.props.name === "myDocumentStatusInfo") ||
                                        (this.props.name === "documentStatusInfo")) &&
                                        showEdefterDocumentStatusInfo(this.state.entIdentifier) &&
                                        <GibDocumentList
                                            type="edefter"
                                            dateType=''
                                            handleDetail={this.handleDetail}
                                            documentName="EDefter"
                                            documentTitle="EDefter Detay Listesi"
                                            refresh={this.state.refresh}
                                            showOnDocuments={this.state.showOwnDocuments}
                                        />
                                    }
                                    {((this.props.isEDefterBildirim && this.props.name === "myDocumentStatusInfo") ||
                                        (this.props.name === "documentStatusInfo")) &&
                                        showEdefterBildirimDocumentStatusInfo(this.state.entIdentifier) &&
                                        <GibDocumentList
                                            type="edefter-bildirim"
                                            dateType=''
                                            handleDetail={this.handleDetail}
                                            documentName="EDefter-Bildirim"
                                            documentTitle="EDefter-Bildirim Detay Listesi"
                                            refresh={this.state.refresh}
                                            showOnDocuments={this.state.showOwnDocuments}
                                        />
                                    }
                                    {(this.props.name !== "myDocumentStatusInfo") &&
                                        (this.isEntegrator() && showSgkInvoiceInfo()) &&
                                        < GibDocumentList
                                            type="sgkInvoice"
                                            dateType=''
                                            handleDetail={this.handleDetail}
                                            documentName="SGK Faturası Durumu"
                                            documentTitle="SGK Faturası Durumu"
                                            refresh={this.state.refresh}
                                        />
                                    }
                                </div>

                            </div>
                            :
                            <div>
                                <div className="card-body" style={{paddingBottom: '0px'}}>
                                    <div>
                                        <div style={{marginTop: '10px', marginBottom: '0px'}}>
                                            <DetailedSearch fields={fields}
                                                            loading={this.state.searching}
                                                            onSearch={this.handleSearch}/>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12">
                                    <h6>{this.state.documentTitle} {this.state.documentType === "sgkInvoice" ? this.state.sgkType === "pharmacy" ? " - Eczacı" : " - Optisyen"

                                        :
                                        ""
                                    }</h6>
                                    {this.state.content.length > 0 && this.state.dateType !== "month" && this.state.selectedProcessState.state === 120 && this.state.selectedProcessState.result === 3 &&
                                    <button style={{marginBottom: "10px"}} className="TekBtn detay genislik"
                                            onClick={(e) => this.changeAllProcessState()}>
                                        Tümünü İmzaya Gönder
                                    </button>
                                    }
                                    <CTable
                                        columns={columns}
                                        loading={this.state.loading}
                                        loadingText="Kayıtlar getiriliyor..."
                                        content={this.state.content}
                                        total={this.state.total}
                                        page={this.state.page}
                                        manual={this.state.manual}
                                        size={this.state.size}
                                        options={["5", "10", "20", "50", "100", "250"]}
                                        fetchData={this.fetchDetail}
                                        getTrStyles={this.getTrStyles}
                                    />
                                </div>
                            </div>
                    }
                </div>

            </div>
        );
    }
}
export default DocumentStatusInfo;